export * from 'server/models/BillExportPayloadAssignment';


// WEBPACK FOOTER //
// ./data/models/BillExportPayloadAssignment.ts